angular.module('storefront.account')
    .component('vcAccountSubscriptions', {
        templateUrl: 'themes/assets/js/account/account-subscriptions.tpl.liquid',
        $routeConfig: [
            {
                path: '/',
                name: 'SubscriptionList',
                component: 'vcAccountSubscriptionsList',
                useAsDefault: true,
            },
            {
                path: '/:number',
                name: 'SubscriptionDetail',
                component: 'vcAccountSubscriptionDetail',
            },
        ],
    })

    .component('vcAccountSubscriptionsList', {
        templateUrl: 'account-subscriptions-list.tpl',
        controller: [
            'storefront.subscriptionApi',
            'confirmService',
            'loadingIndicatorService',
            function (
                subscriptionApi,
                confirmService,
                loader,
            ) {
                const $ctrl = this;

                $ctrl.loader = loader;
                $ctrl.pageSettings = {
                    currentPage: 1,
                    itemsPerPageCount: 5,
                    numPages: 10,
                };
                $ctrl.pageSettings.pageChanged = function () {
                    loader.wrapLoading(function () {
                        return subscriptionApi.search({
                            pageNumber: $ctrl.pageSettings.currentPage,
                            pageSize: $ctrl.pageSettings.itemsPerPageCount,
                            sortInfos: $ctrl.sortInfos,
                        }, function (data) {
                            $ctrl.entries = data.results;
                            $ctrl.pageSettings.totalItems = data.totalCount;
                        }).$promise;
                    });
                };

                this.$routerOnActivate = function (next) {
                    $ctrl.pageSettings.currentPage = next.params.pageNumber || $ctrl.pageSettings.currentPage;
                    $ctrl.pageSettings.pageChanged();
                };
            }],
    })

    .component('vcAccountSubscriptionDetail', {
        templateUrl: 'account-subscription-detail.tpl',
        controller: [
            'storefront.subscriptionApi',
            'confirmService',
            'loadingIndicatorService',
            function (
                subscriptionApi,
                confirmService,
                loader,
            ) {
                const $ctrl = this;

                $ctrl.loader = loader;

                function refresh() {
                    loader.wrapLoading(function () {
                        return subscriptionApi.get({ number: $ctrl.entryNumber }, function (result) {
                            $ctrl.subscription = angular.copy(result);
                        }).$promise;
                    });
                }

                this.$routerOnActivate = function (next) {
                    $ctrl.pageNumber = next.params.pageNumber || 1;
                    $ctrl.entryNumber = next.params.number;

                    refresh();
                };

                $ctrl.cancel = function () {
                    // var showDialog = function (text) {
                    //    confirmService.confirm(text).then(function (confirmed) {
                    //        if (confirmed) {
                    loader.wrapLoading(function () {
                        return subscriptionApi.cancel({ number: $ctrl.entryNumber }, {
                            number: $ctrl.entryNumber,
                            cancelReason: $ctrl.cancelReason,
                        }, function (result) {
                            $ctrl.subscription = angular.copy(result);
                            $ctrl.isCancelFormVisible = false;
                        }).$promise;
                    });
                    //        }
                    //    });
                    // };
                    // $translate('customer.subscription.cancel_confirmation').then(showDialog, showDialog);
                };
            }],
    })

    .filter('toIntervalKey', function () {
        return function (data, dataIntervalCount) {
            return 'customer.subscriptions.intervals.'
                + data.interval.toLowerCase() + '_'
                + (dataIntervalCount === 1 ? 1 : 'plural');

            // var everyKey = 'customer.subscriptions.intervals.every';
            //
            // $translate([intervalKey, everyKey])
            //     .then(function (translations) {
            //         var intervalVal = translations[intervalKey];
            //         var everyVal = translations[everyKey];
            //
            //         if (dataIntervalCount === 1) {
            //             retVal = intervalKey;
            //         } else {
            //             retVal = dataIntervalCount + intervalVal;
            //         }
            //     });
        };
    });
